import { Navigate, useLocation } from "react-router-dom";

import { useSessionScope } from "@/lib/session-scope";

/**
 * Gates the app behind a chosen legal entity + operation unit. Without one the user is sent
 * to /select-scope?next=<path> and comes back after picking.
 */
export function RequireScope({ children }: { children: React.ReactNode }) {
  const { scope } = useSessionScope();
  const location = useLocation();

  if (!scope) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/select-scope?next=${next}`} replace />;
  }
  return <>{children}</>;
}
